<template>
  <div>
    <presentation v-if="presentation" :presentation="presentation" />
  </div>
</template>

<script>
import presentation from "@/components/presentation";
export default {
  name: "present",
  components: {
    presentation
  },
  mounted() {
    this.getPresentation();
  },
  methods: {
    getPresentation() {
      debugger;
      this.guide = {};
      this.$store
        .dispatch("listings/getPresentationBySlug", this.$route.params.slug)
        .then(res => {
          this.presentation = res;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  data() {
    return {
      presentation: null
    };
  }
};
</script>
